var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6409 14.9045C22.0381 21.3339 15.5262 25.2467 9.09606 23.6434C2.66863 22.0405 -1.24415 15.5282 0.359423 9.09939C1.96159 2.66933 8.47348 -1.24375 14.9016 0.359121C21.3313 1.96199 25.2438 8.475 23.6408 14.9046L23.6409 14.9045H23.6409ZM12.0895 15.0512L7 12.1484L12.0895 4L17.1788 12.1484L12.0895 15.0512ZM12.0894 19.9999L7 13.0797L12.0894 15.981H12.0895L17.1819 13.0797L12.0894 20L12.0894 19.9999Z",
    fill: "#DAA636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0895 4L7 12.1484L12.0895 15.0512V9.91623V4Z",
    fill: "#222222",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0894 15.981L12.0267 16.0548V19.8234L12.0894 20L17.1819 13.0797L12.0894 15.981Z",
    fill: "#222222",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0895 20V15.981L7 13.0797L12.0895 20Z",
    fill: "#222222",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9782 4.36462L12.0895 4L17.1788 12.1484L12.0894 9.91626L12.0895 15.0513L11.9782 14.9442V4.36462Z",
    fill: "#222222",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.1485L12.0895 15.0513V9.91626L7 12.1485Z",
    fill: "#222222",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.891a85c5602cee9c0d6702008cb28538.svg";
export { ForwardRef as ReactComponent };